<template>
  <div>
    <v-card-actions>
      <v-row>
        <v-col class="text-right">
          <v-btn
            v-if="reserve && guests.length > 0"
            :loading="loadingPrintGuests"
            x-large
            outlined
            color="secondary"
            class="mr-4"
            @click="printFicha()"
          >
            <v-icon left>
              {{ icons.mdiCardAccountDetailsOutline }}
            </v-icon>
            Imprimir Ficha
          </v-btn>
          <v-btn
            :loading="loadingCheckin"
            x-large
            color="success"
            @click="sendCheckIn()"
          >
            Check-In
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-text>
      <v-row
        no-gutters
        class="mt-4"
      >
        <v-col>
          <AutocompleteSearchReserve
            v-model="reserve"
            @change="applyReserve"
          ></AutocompleteSearchReserve>
          <v-alert
            v-if="preCheckinIncomplete"
            type="warning"
            outlined
            dense
            class="mt-2 mb-0"
          >
            <strong>Pré-check-in incompleto.</strong>
            {{ reserve.pre_checkin_completed_guests }} de {{ reserve.pre_checkin_total_guests }} hóspedes concluíram o cadastro.
          </v-alert>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify="end"
      >
        <v-col cols="2">
          <vuetify-money
            v-model="dataCheckIn.accommodation_value"
            label="Valor da Hospedagem"
            disabled
            outlined
          ></vuetify-money>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class=""
      >
        <v-col
          cols="3"
          class="mr-2"
        >
          <SelectCategoryRoom
            v-model="dataCheckIn.room_category_id"
            :errors="errors.room_category_id"
            class="mr-4"
            @change="errors.room_category_id = ''"
          />
        </v-col>
        <v-col cols="2">
          <v-switch
            v-model="dataCheckIn.tariff_manual"
            true-value="yes"
            false-value="not"
            label="Tarifa Manual"
          ></v-switch>
        </v-col>
        <v-col
          v-if="dataCheckIn.tariff_manual == 'not'"
          cols=""
        >
          <v-autocomplete
            v-model="selectedRatePlanId"
            :items="availableRatePlans"
            item-value="id"
            item-text="description"
            label="Tarifário"
            outlined
            class="mr-4"
            :error-messages="errors.rate_plan_id"
            @change="applyRatePlanValue()"
          ></v-autocomplete>
        </v-col>
        <v-col
          v-if="dataCheckIn.tariff_manual == 'yes'"
          cols=""
        >
          <vuetify-money
            v-model="tariff_manual_value"
            :erros="errors.tariff_manual_value"
            outlined
            label="Tarifa"
            class="mr-4"
          />
        </v-col>
        <v-col
          cols=""
          class="ml-2"
        >
          <input-date
            v-model="dataCheckIn.check_out"
            :errors="errors.check_out"
            :dense="false"
            :label="'Check-out'"
            @change="errors.check_out = ''; createTarif()"
          ></input-date>
        </v-col>
        <v-col>
          <v-btn
            color="primary"
            class="ml-4"
            @click="showDialogTariffExtraordinary"
          >
            <v-icon>{{ icons.mdiPencilOutline }}</v-icon>
            TARIFAS
          </v-btn>
        </v-col>
      </v-row>

      <v-row
        no-gutters
        class="mb-2"
      >
        <v-col
          cols="3"
          class="mr-2"
        >
          <v-text-field
            v-model="dataCheckIn.car_license_plate"
            outlined
            label="Placa Automóvel"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
          class="mr-2"
        >
          <v-select
            v-model="dataCheckIn.transport_type"
            :items="meiosTransporte"
            item-text="label"
            item-value="codigo"
            outlined
            label="Meio de Transporte"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="dataCheckIn.travel_reason"
            :items="motivosViagem"
            item-text="label"
            item-value="codigo"
            outlined
            label="Motivo da Viagem"
            clearable
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card outlined>
            <v-data-table
              dense
              :headers="headersgGuestUnknown"
              disable-sort
              :items="guest_unknown"
              :footer-props="{
                itemsPerPageText: 'Itens por pagina',
                itemsPerPageOptions: [5],
                showFirstLastPage: true,
              }"
            >
            </v-data-table>
          </v-card>
        </v-col>
        <v-col
          v-if="billingEnabled || (reserve && reserve.obs)"
          cols="6"
        >
          <v-card
            v-if="billingEnabled"
            outlined
          >
            <div class="text-uppercase font-weight-medium caption grey--text pa-2 pl-4">
              Meio de Pagamento
            </div>
            <v-divider></v-divider>
            <div class="pa-3 d-flex align-center">
              <v-chip
                x-small
                color="primary"
                text-color="white"
                class="mr-2"
              >
                Faturado
              </v-chip>
              <span class="caption">{{ billingScopeLabel }}</span>
            </div>
            <v-alert
              v-if="companyCredit.billing_blocked"
              type="error"
              dense
              text
              class="mx-3 mb-3 caption"
            >
              Faturamento bloqueado: faturas vencidas há {{ companyCredit.overdue_days }} dias.
            </v-alert>
          </v-card>
          <v-card
            v-if="reserve && reserve.obs"
            outlined
            :class="billingEnabled ? 'mt-2' : ''"
          >
            <div class="text-uppercase font-weight-medium caption grey--text pa-2 pl-4">
              Observações da Reserva
            </div>
            <v-divider></v-divider>
            <div class="pa-3 body-2">
              {{ reserve.obs }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col>
          <TableGuest
            v-model="guest"
            :errors="errors.guest"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <!-- DIALOG TARIFAS EXTRAORDINARIAS -->
    <v-dialog
      v-model="dialogTariffExtraordinary"
      persistent
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Tarifas"
          @close="dialogTariffExtraordinary = false"
        />
        <v-card-text>
          <!-- v-for=" tariff in editedItem.extraordinary_tariff   " -->
          <v-row
            v-for="tariff in extraordinary_tariff"
            no-gutters
            class="mb-2"
          >
            <v-col>
              <vuetify-money
                v-model="tariff.value"
                :option="{ prefix: 'R$' }"
                dense
                outlined
                hide-details
              ></vuetify-money>
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                readonly
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_start)"
                label="Data Inicio"
              ></v-text-field>
              <!-- <input-date css="ml-2" v-model="tariff.date_start" :label="'Data Inicial'" :dense="true"></input-date> -->
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                readonly
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_end)"
                label="Data Fim"
              ></v-text-field>
              <!-- <input-date css="ml-2" v-model="tariff.date_end" :label="'Data Final'" :dense="true"></input-date> -->
            </v-col>
            <!-- <v-col cols="1"> -->
            <!-- <v-btn icon color="error" class="ml-2" @click="removeTariffExtraordinary(tariff)" >
                            <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                        </v-btn> -->
            <!-- </v-col> -->
          </v-row>
          <!-- <v-row>
                    <v-col class="text-center"> -->
          <!-- <v-btn rounded  color="secondary" @click="addTariffExtraordinary()" >
                            <v-icon>{{ icons.mdiPlus }}</v-icon>
                            Adicionar Tarifa
                        </v-btn> -->
          <!-- </v-col>
                </v-row> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                text
                class="mr-4"
                @click="dialogTariffExtraordinary = false"
              >
                fechar
              </v-btn>
              <v-btn
                x-large
                color="primary"
                @click="confirmExtraordinaryTariff()"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiCardAccountDetailsOutline, mdiDeleteOutline, mdiPencilOutline, mdiPlus,
} from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import AutocompleteSearchCompanyVue from '@/components/AutocompleteSearchCompany.vue'
import AutocompleteSearchReserve from '@/components/AutocompleteSearchReserve.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import InputDate from '@/components/InputDate.vue'
import SelectCategoryRoom from '@/components/SelectCategoryRoom.vue'
import TableGuest from './TableGuest.vue'

export default {
  components: {
    AutocompleteSearchCompanyVue,
    InputDate,
    TableGuest,
    SelectCategoryRoom,
    AutocompleteSearchReserve,
    BarTitleDialog,
  },
  props: {
    room: {
      type: Object,
    },
  },
  data: () => ({
    meiosTransporte: [],
    motivosViagem: [],
    dialogTariffExtraordinary: false,
    extraordinary_tariff: [],
    tariffObject: {},
    ratePlans: [],
    selectedRatePlanId: null,
    headersgGuestUnknown: [
      {
        text: 'HÓSPEDES',
        align: 'start',
        value: 'name',
      },
    ],
    audit: {},
    reserveTariff: false,
    loadingCheckin: false,
    loadingPrintGuests: false,
    guest: [],
    config: {},
    guest_unknown: [],
    company: null,
    reserve: null,
    dataCheckIn: {
      tariff_manual: 'not',
      rate_plan_id: null,
    },
    tariff_manual_value: '',

    icons: {
      mdiDeleteOutline,
      mdiPlus,
      mdiPencilOutline,
      mdiCardAccountDetailsOutline,
    },
    errors: {
      room_category_id: null,
      rate_plan_id: null,
      check_in: null,
      check_out: null,
      company_id: null,
      guest: null,
      room: [],
    },
    tarifManualInitial: null, // parta da gambiarra
    companyCredit: {
      billing_blocked: false,
      overdue_days: 0,
    },
    billingScopes: {
      total: 'Total da conta',
      accommodation: 'Somente hospedagem',
      consumption: 'Somente consumo',
    },
  }),
  watch: {
    tariff_manual_value(val) {
      // gambiarra pq o onchange no comoponenete vutify-money não funciona
      if (val != this.tarifManualInitial) {
        this.createTarif()
      }
    },
    room() {
      this.reserve = null
      this.dataCheckIn = {
        tariff_manual: 'not',
        rate_plan_id: null,
      }
      this.guest = []
      this.guest_unknown = []
      this.extraordinary_tariff = []
      this.selectedRatePlanId = null
      this.companyCredit = { billing_blocked: false, overdue_days: 0 }
      this.autoApplyReserve()
    },
    guest() {
      if (this.guest.length > 0) {
        this.errors.guest = ''
      }
    },
  },
  created() {
    this.loadRatePlans().then(response => {
      this.ratePlans = response.data || []
    })
    this.config = this.loadConfig().then(response => {
      this.config = response.data
    })
    this.hasAudit().then(response => {
      this.audit = response.data
    })
    this.loadFnrhDominios()
    this.autoApplyReserve()
  },
  computed: {
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),
    guests() {
      // fitrar os hospedes q estao cadastrados
      const guests = this.guest.filter(guest => guest.origin !== 'unknown')

      return guests
    },
    billingEnabled() {
      return Boolean(this.reserve && this.reserve.billing_checkout_enabled)
    },
    billingScopeLabel() {
      return this.billingScopes[this.reserve?.billing_checkout_scope] || 'Total da conta'
    },
    preCheckinIncomplete() {
      return this.reserve
        && Number(this.reserve.pre_checkin_total_guests) > 0
        && Number(this.reserve.pre_checkin_completed_guests) > 0
        && Number(this.reserve.pre_checkin_completed_guests) < Number(this.reserve.pre_checkin_total_guests)
    },
    availableRatePlans() {
      const categoryId = Number(this.dataCheckIn.room_category_id)
      const checkIn = this.reserve?.check_in || this.dataCheckIn.check_in
      const checkOut = this.dataCheckIn.check_out
      const isIsoDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '')

      if (!categoryId || !isIsoDate(checkIn) || !isIsoDate(checkOut)) return []

      const plans = this.ratePlans.filter(plan => {
        if (!isIsoDate(plan.date_start) || !isIsoDate(plan.date_end)) return false

        return plan.date_start <= checkIn
          && plan.date_end >= checkOut
          && (plan.items || []).some(item => Number(item.room_category_id) === categoryId)
      })

      const linkedPlan = this.reserve?.rate_plan
      if (linkedPlan && !plans.some(plan => Number(plan.id) === Number(linkedPlan.id))) {
        plans.unshift(linkedPlan)
      }

      return plans
    },
  },
  methods: {
    ...mapActions('reserved', ['checkIn']),
    ...mapActions('config', ['loadConfig']),
    ...mapActions('audit', ['hasAudit']),
    ...mapActions('select', ['get_fnrh_dominios']),
    ...mapActions('rate_plan', { loadRatePlans: 'getForSelect' }),
    ...mapActions('reserve', ['printGuestSheetsPreview']),
    ...mapActions('company', ['getCompanyCredit']),

    printFicha() {
      if (!this.reserve || this.guests.length === 0) return

      this.loadingPrintGuests = true
      this.printGuestSheetsPreview({ reserveId: this.reserve.id, guestIds: this.guests.map(g => g.id) })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', `fichas_hospedes_${this.reserve.id}.pdf`)
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(() => {
          this.$toast.error('Erro ao gerar fichas dos hóspedes.')
        })
        .finally(() => {
          this.loadingPrintGuests = false
        })
    },

    async loadFnrhDominios() {
      const [transport, reason] = await Promise.all([
        this.get_fnrh_dominios('meios_transporte'),
        this.get_fnrh_dominios('motivos_viagem'),
      ])
      this.meiosTransporte = transport.data
      this.motivosViagem = reason.data
    },

    setTariffObject(object) {
      this.tariffObject = object
      this.calcAccommodationValue()
    },
    applyRatePlanValue() {
      const plan = this.availableRatePlans.find(item => Number(item.id) === Number(this.selectedRatePlanId))
      if (!plan) return

      const item = (plan.items || []).find(rate => Number(rate.room_category_id) === Number(this.dataCheckIn.room_category_id))
      if (!item) return

      this.dataCheckIn.rate_plan_id = plan.id
      this.errors.rate_plan_id = null
      this.tariffObject = { value: Number(item.value) }
    },
    showDialogTariffExtraordinary() {
      this.dialogTariffExtraordinary = true
    },
    addTariffExtraordinary() {
      this.extraordinary_tariff.push({ value: 0, date_start: '', date_end: '' })
    },
    removeTariffExtraordinary(tariff) {
      const index = this.extraordinary_tariff.indexOf(tariff)
      this.extraordinary_tariff.splice(index, 1)
    },

    autoApplyReserve() {
      // quarto já vinculado a uma reserva (marcado como "reservado"): pré-carrega
      // a reserva no formulário em vez de exigir busca manual
      const reserve = this.room?.current_reserve || this.room?.today_reserve
      if (reserve) {
        this.reserve = reserve
        this.applyReserve(reserve)
      }
    },
    applyReserve(reserve) {
      if (!reserve) {
        // reserva removida do campo: limpa o form pra permitir busca manual
        this.dataCheckIn = {
          tariff_manual: 'not',
          rate_plan_id: null,
        }
        this.guest = []
        this.guest_unknown = []
        this.extraordinary_tariff = []
        this.selectedRatePlanId = null

        return
      }

      // VALIDAÇÃO: Verifica se pode fazer check-in desta reserva
      const validation = this.validateReserveCheckIn(reserve)

      if (!validation.allowed) {
        this.$swal({
          confirmButtonColor: '#16b1ff',
          position: 'center',
          html: `<p>${validation.reason}</p>`,
          icon: 'error',
          title: 'Check-in não permitido',
        }).then(() => {
          // Fecha o modal após mostrar o erro
          this.$emit('close')
        })

        return // Interrompe a aplicação da reserva
      }

      this.dataCheckIn.with_iss = reserve.with_iss
      const local = new Date(Date.now())
      const checkIn = new Date(this.dateConvert(local))
      this.dataCheckIn.check_in = checkIn.toISOString().split('T')[0]

      // Sempre usa o checkout da reserva
      this.dataCheckIn.check_out = reserve.check_out

      this.dataCheckIn.room_category_id = reserve.room_category_id
      this.dataCheckIn.tariff_manual = reserve.tariff_manual
      this.tariff_manual_value = reserve.tariff_manual_value
      this.tarifManualInitial = reserve.tariff_manual_value
      this.dataCheckIn.rate_plan_id = reserve.rate_plan_id
      this.selectedRatePlanId = reserve.rate_plan_id || null
      this.tariffObject = reserve.tariff || {}
      this.dataCheckIn.company_id = reserve.company_id
      this.guest = reserve.guest
      this.guest_unknown = reserve.guest_unknown
      this.extraordinary_tariff = reserve.extraordinary_tariff

      // Usa o valor da reserva diretamente
      this.dataCheckIn.accommodation_value = reserve.accommodation_value

      this.calcAccommodationValue()
      this.fetchBillingBlockStatus(reserve)
    },
    fetchBillingBlockStatus(reserve) {
      this.companyCredit = { billing_blocked: false, overdue_days: 0 }

      if (!reserve.billing_checkout_enabled || !reserve.company_id) return

      this.getCompanyCredit(reserve.company_id)
        .then(response => {
          const creditData = (response.data && response.data.data) ? response.data.data : {}
          this.companyCredit = {
            billing_blocked: Boolean(creditData.billing_blocked),
            overdue_days: Number(creditData.overdue_days || 0),
          }
        })
        .catch(() => {
          this.companyCredit = { billing_blocked: false, overdue_days: 0 }
        })
    },
    createTarif() {
      this.reserveTariff = false
      this.errors.rate_plan_id = ''

      // Usa a data de check-in da RESERVA (não a data atual)
      if (!this.reserve || !this.reserve.check_in) {
        console.warn('Reserva não selecionada ou sem data de check-in')

        return
      }

      // Parse das datas
      const reserveCheckIn = this.reserve.check_in.split('T')[0]
      const reserveCheckOut = this.reserve.check_out.split('T')[0]
      const newCheckOut = this.dataCheckIn.check_out.split('T')[0]

      // Tarifas originais da reserva
      const originalTariffs = [...this.reserve.extraordinary_tariff]

      if (originalTariffs.length === 0) {
        console.warn('Reserva sem tarifas cadastradas')

        return
      }

      // CASO 1: Checkout NÃO foi alterado - mantém tarifas originais
      if (newCheckOut === reserveCheckOut) {
        this.extraordinary_tariff = originalTariffs
        this.calcAccommodationValue()

        return
      }

      // CASO 2: ANTECIPAÇÃO - Remove diárias do final
      if (newCheckOut < reserveCheckOut) {
        const filteredTariffs = originalTariffs.filter(tariff => {
          const tariffEnd = tariff.date_end.split('T')[0]

          return tariffEnd <= newCheckOut
        })

        this.extraordinary_tariff = filteredTariffs
        this.calcAccommodationValue()

        return
      }

      // CASO 3: EXTENSÃO - Adiciona diárias baseadas na última tarifa
      if (newCheckOut > reserveCheckOut) {
        // Pega o valor da última tarifa da reserva
        const lastTariff = originalTariffs[originalTariffs.length - 1]
        const lastValue = lastTariff.value

        // Começa com as tarifas originais
        const extendedTariffs = [...originalTariffs]

        // Calcula quantos dias adicionais precisa
        const lastCheckOut = new Date(`${reserveCheckOut}T00:00:00`)
        const finalCheckOut = new Date(`${newCheckOut}T00:00:00`)
        const diffInMs = finalCheckOut - lastCheckOut
        const additionalDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24))

        // Adiciona novas diárias com o valor da última
        const currentDate = new Date(lastCheckOut)

        for (let i = 0; i < additionalDays; i++) {
          const date_start = currentDate.toISOString().split('T')[0]
          currentDate.setDate(currentDate.getDate() + 1)
          const date_end = currentDate.toISOString().split('T')[0]

          extendedTariffs.push({
            value: lastValue,
            date_start,
            date_end,
          })
        }

        this.extraordinary_tariff = extendedTariffs
        this.calcAccommodationValue()

        return
      }

      // Fallback - não deveria chegar aqui
      this.extraordinary_tariff = originalTariffs
      this.calcAccommodationValue()
    },

    calcAccommodationValue() {
      let result = this.extraordinary_tariff.reduce((acc, tariff) => acc + parseFloat(tariff.value), 0)

      if (this.dataCheckIn.with_iss == 'yes') {
        // calc de iss
        if (result > 0) {
          const iss = result * this.issRate
          result += iss
        }
      }

      this.dataCheckIn.accommodation_value = result
    },

    confirmExtraordinaryTariff() {
      this.calcAccommodationValue()
      this.dialogTariffExtraordinary = false
    },
    sendCheckIn(confirmIncompletePreCheckin = false) {
      // Valida os dados
      if (!this.validations()) return

      // Se não for de reserva, não permite (deve usar walk-in)
      if (!this.reserve) {
        this.$swal({
          confirmButtonColor: '#16b1ff',
          position: 'center',
          html: '<p>Para check-in sem reserva, utilize a opção Walk-In.</p>',
          icon: 'warning',
          title: 'Atenção',
        })

        return
      }

      if (this.preCheckinIncomplete && !confirmIncompletePreCheckin) {
        this.confirmIncompletePreCheckin()

        return
      }

      this.loadingCheckin = true
      this.dataCheckIn.guest = this.guests
      this.dataCheckIn.room_id = this.room.id
      this.dataCheckIn.reserve_id = this.reserve.id
      this.dataCheckIn.confirm_incomplete_precheckin = confirmIncompletePreCheckin

      // Usa as tarifas da reserva diretamente (não calcula mais)
      this.dataCheckIn.accommodation_item = this.extraordinary_tariff

      this.checkIn(this.dataCheckIn)
        .then(response => {
          this.$emit('close') // envia evento para fechar o dialog
          this.$toast.success('Check-In realizado')
          this.$emit('updategrid') // evento atualiza a grade de quartos
        })
        .catch(error => {
          // Trata erros de validação do backend
          if (error.response?.data?.precheckin_confirmation_required) {
            this.confirmIncompletePreCheckin()
          } else if (error.response && error.response.data && error.response.data.validation_failed) {
            this.$swal({
              confirmButtonColor: '#16b1ff',
              position: 'center',
              html: `<p>${error.response.data.error}</p>`,
              icon: 'error',
              title: 'Check-in não permitido',
            })
          } else {
            this.$toast.error('Erro ao realizar check-in')
          }
        })
        .finally(() => {
          this.loadingCheckin = false
        })
    },
    confirmIncompletePreCheckin() {
      const completed = Number(this.reserve.pre_checkin_completed_guests) || 0
      const total = Number(this.reserve.pre_checkin_total_guests) || 0
      const pending = Math.max(total - completed, 0)

      this.$swal({
        confirmButtonColor: '#fb8c00',
        cancelButtonColor: '#757575',
        showCancelButton: true,
        confirmButtonText: 'Continuar check-in',
        cancelButtonText: 'Cancelar',
        position: 'center',
        html: `<p>${completed} de ${total} hóspedes concluíram o cadastro.</p><p>Ainda ${pending === 1 ? 'existe 1 hóspede pendente' : `existem ${pending} hóspedes pendentes`}.</p>`,
        icon: 'warning',
        title: 'Pré-check-in incompleto',
      }).then(result => {
        if (result.isConfirmed) this.sendCheckIn(true)
      })
    },
    formatDate(date) {
      // const date = this.date
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },

    /**
     * Valida se pode fazer check-in de uma reserva (MESMA LÓGICA DO BACKEND)
     */
    validateReserveCheckIn(reserve) {
      const now = new Date()
      const pad = value => String(value).padStart(2, '0')
      const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      const currentTime = now.toTimeString().slice(0, 5) // HH:mm

      // Pega horário de checkout da configuração (padrão 12:00 se não configurado)
      const checkoutTime = this.config.checkout || '12:00'

      // IMPORTANTE: Parse da data sem conversão de timezone
      const reserveCheckIn = reserve.check_in.split('T')[0]

      // Calcula diferença em dias (INVERTIDO para ficar igual ao backend)
      const todayDate = new Date(`${today}T00:00:00`)
      const reserveDate = new Date(`${reserveCheckIn}T00:00:00`)
      const daysDiff = Math.floor((reserveDate - todayDate) / (1000 * 60 * 60 * 24))

      // CASO 1: Check-in no dia correto da reserva
      if (reserveCheckIn === today) {
        return {
          allowed: true,
          reason: null,
        }
      }

      // CASO 2: Check-in no dia seguinte da reserva (até horário de checkout)
      // Reserva do dia 13/11 pode fazer check-in até 14/11 às 12:00
      if (daysDiff === -1) { // Reserva era ontem
        // Se ainda não passou o horário de checkout → PERMITIR
        if (currentTime < checkoutTime) {
          return {
            allowed: true,
            reason: null,
          }
        }

        // Se já passou o horário de checkout → BLOQUEAR
        return {
          allowed: false,
          reason: `O horário para check-in desta reserva expirou às ${checkoutTime}. Por favor, altere a reserva para prosseguir.`,
        }
      }

      // CASO 3: Reserva com 2+ dias atrasada → BLOQUEAR
      if (daysDiff < -1) {
        const [year, month, day] = reserveCheckIn.split('-')
        const formattedDate = `${day}/${month}/${year}`

        return {
          allowed: false,
          reason: `Esta reserva está com data incompatível (${formattedDate}). Por favor, altere a reserva para prosseguir com o check-in.`,
        }
      }

      // CASO 4: Reserva para o futuro → BLOQUEAR
      if (daysDiff > 0) {
        const [year, month, day] = reserveCheckIn.split('-')
        const formattedDate = `${day}/${month}/${year}`

        return {
          allowed: false,
          reason: `Não é possível fazer check-in de uma reserva futura (${formattedDate}).`,
        }
      }

      // Fallback
      return {
        allowed: false,
        reason: 'Erro ao validar data do check-in.',
      }
    },

    // Validacões
    validations() {
      let validate = true
      const [hours, minutes] = this.config.checkout.split(':')
      const checkIn = new Date(this.dataCheckIn.check_in)
      const checkOut = new Date(this.dataCheckIn.check_out)
      checkOut.setHours(checkOut.getHours() + 3)
      checkOut.setHours(hours)
      checkIn.setMinutes(minutes)

      // valida a cetegoria do quarto
      if (this.dataCheckIn.room_category_id == null || this.dataCheckIn.room_category_id == undefined) {
        this.errors.room_category_id = 'Campo obrigatório'
        validate = false
      }

      // valida tarifa padrao
      if (this.dataCheckIn.tariff_manual == 'not') {
        const hasStoredDailyRates = this.reserve
          && Array.isArray(this.reserve.extraordinary_tariff)
          && this.reserve.extraordinary_tariff.length > 0
        if (!hasStoredDailyRates && !this.dataCheckIn.rate_plan_id) {
          this.errors.rate_plan_id = 'Selecione um tarifário válido'
          validate = false
        }
      }

      // valida tarifa manual
      if (this.dataCheckIn.tariff_manual == 'yes') {
        // se estiver abilitado para tarifa padrao
        if (
          this.tariff_manual_value == null
          || this.tariff_manual_value == undefined
        ) {
          this.errors.tariff_manual_value = 'Campo obrigatório'
          validate = false
        }
      }

      // valida data checkout
      if (
        this.dataCheckIn.check_out == null
        || this.dataCheckIn.check_out == undefined
        || this.dataCheckIn.check_out == ''
      ) {
        this.errors.check_out = 'Campo obrigatório'
        validate = false
      }

      // valida se a checkout e maior q adata de checkin
      if (checkIn > checkOut) {
        this.errors.check_out = 'Data de checkout deve ser maior que a data atual'
        validate = false
      }

      // valida se tem hopede ou empresa
      const guest = false

      if (this.guest.length == 0) {
        this.errors.guest = 'Obrigatório preencher hóspede'
        validate = false
      }

      return validate
    },

    dateConvert(date) {
      const dateStr = date.toLocaleString('pt-BR')
      let split = dateStr.split(',')
      split = split[0].split('/')

      return `${split[2]}-${split[1]}-${split[0]}`
    },
  },
}
</script>
